import { Link } from 'react-router-dom';
import { BRAND } from '../lib/constants';

const Section = ({ n, title, children, testId }) => (
  <section className="mt-12 first:mt-0" data-testid={testId}>
    <div className="flex items-baseline gap-4">
      <div className="font-serif text-2xl text-[#eb5381] shrink-0">{n}.</div>
      <h2 className="font-serif text-2xl md:text-3xl tracking-tight leading-tight">{title}</h2>
    </div>
    <div className="mt-5 pl-9 md:pl-12 text-base text-neutral-800 leading-relaxed space-y-4">
      {children}
    </div>
  </section>
);

const SubHead = ({ children }) => (
  <h3 className="font-serif text-xl text-[#a465a8] mt-6 mb-2">{children}</h3>
);

const Bullets = ({ items }) => (
  <ul className="list-none space-y-2 mt-2">
    {items.map((it, i) => (
      <li key={i} className="flex gap-3"><span className="text-[#eb5381] mt-1.5 w-1.5 h-1.5 rounded-full bg-[#eb5381] shrink-0" /> <span>{it}</span></li>
    ))}
  </ul>
);

export const LegalLayout = ({ title, effective, intro, children, testId }) => (
  <div data-testid={testId} className="bg-white">
    <section className="bg-[#ffefd1] pt-32 pb-16 md:pb-20">
      <div className="container-edge">
        <div className="text-[11px] uppercase tracking-[0.3em] text-[#eb5381]">Legal</div>
        <h1 className="mt-3 font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1] tracking-tight max-w-5xl">
          {title}
        </h1>
        <p className="mt-5 text-xs sm:text-sm uppercase tracking-[0.2em] text-neutral-600">Effective Date: {effective}</p>
        {intro && <p className="mt-6 max-w-3xl text-base md:text-lg text-neutral-700 leading-relaxed">{intro}</p>}
      </div>
    </section>

    <article className="container-edge py-14 md:py-20">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-9 min-w-0">
          {children}
        </div>
        <aside className="lg:col-span-3 hidden lg:block">
          <div className="sticky top-28 border-l border-[#eaeaea] pl-6 text-sm">
            <div className="text-[10px] uppercase tracking-[0.3em] text-[#eb5381]">On this page</div>
            <p className="mt-3 text-neutral-600 leading-relaxed">
              Read each section carefully. For any clarification, write to us at
              {' '}
              <a href={`mailto:${BRAND.email}`} className="text-[#eb5381] underline break-all">{BRAND.email}</a>.
            </p>
            <Link to="/contact" className="mt-4 inline-flex items-center text-[10px] uppercase tracking-[0.25em] text-black hover:text-[#eb5381]">
              Contact support →
            </Link>
          </div>
        </aside>
      </div>
    </article>

    <section className="bg-[#0a0a0a] text-white py-14">
      <div className="container-edge flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="min-w-0">
          <div className="text-[11px] uppercase tracking-[0.3em] text-[#eb5381]">Questions?</div>
          <div className="mt-2 font-serif text-2xl md:text-3xl">Write to us — we're listening.</div>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
          <a href={`mailto:${BRAND.email}`} className="inline-flex items-center justify-center bg-[#eb5381] hover:bg-[#d64570] text-white px-6 sm:px-7 py-3 text-[10px] sm:text-[11px] uppercase tracking-[0.25em] transition-colors break-all">
            {BRAND.email}
          </a>
          <Link to="/contact" className="inline-flex items-center justify-center border border-white hover:bg-white hover:text-black px-6 sm:px-7 py-3 text-[10px] sm:text-[11px] uppercase tracking-[0.25em] transition-colors">
            Contact Us
          </Link>
        </div>
      </div>
    </section>
  </div>
);

export { Section, SubHead, Bullets };
